import React from "react";
import { createSlice } from "@reduxjs/toolkit";
import { currentTheme } from "configs/default-features";

interface storageValue {
  value: string | null;
}

export const setUniversalTheme = (name: string, value: string) => {
  document.documentElement.setAttribute(name, value);
  localStorage.setItem(name, value);
};

setUniversalTheme("data-theme", currentTheme);

const ThemeSlice = createSlice({
  name: "theme",
  initialState: {
    currentTheme: currentTheme,
  },
  reducers: {
    setTheme(state, { payload }) {
      state.currentTheme = payload;
      setUniversalTheme("data-theme", state.currentTheme);
    },
    toggleTheme(state) {
      state.currentTheme = state.currentTheme === "light" ? "dark" : "light";
      setUniversalTheme("data-theme", state.currentTheme);
    },
  },
});

export const { setTheme, toggleTheme } = ThemeSlice.actions;
export default ThemeSlice.reducer;
